import { Box, Flex, HStack } from "@chakra-ui/react";
import { FC } from "react";

import { DashboardFeaturedCard } from "components/DashboardFeatCard";
import { FeaturedAuction } from "models/featuredAuction";

type TopActiveListingsProps = {
    cards?: FeaturedAuction[];
};

const TopActiveListings: FC<TopActiveListingsProps> = ({ cards }) => {
    return (
        <Box
            borderRadius="lg"
            style={{
                background: "rgb(0 0 0 / 0.5)",
                width: "100%",
            }}
        >
            <Flex px={4} pt={2} flexDir={{ base: "column", md: "row" }}>
                <Box fontSize={22} fontWeight="semibold" color="white">
                    dcsports87 Featured Listings
                </Box>
            </Flex>

            {/* <Box p={4} style={{ display: "flex", overflowX: "scroll" }}> */}
            <HStack
                color="darkGray"
                flexDir="row"
                px={8}
                py={4}
                spacing={8}
                overflowX="scroll"
            >
                {cards && cards.length > 0 ? (
                    cards.map((card) => (
                        <DashboardFeaturedCard
                            card={card}
                            key={card.auctionUrl}
                        />
                    ))
                ) : (
                    <Box fontSize={16}>No packages</Box>
                )}
            </HStack>
            {/* </Box> */}
        </Box>
    );
};

export default TopActiveListings;
